import { getGlobalConfig } from '@core/globalConfig'
import { isTruthy } from '@core/helpers/boolean'
import { logInfo } from '@core/logging'

function createStoryblock(url: string, channel: string) {
  const fwStoryblock = document.createElement('fw-storyblock')
  fwStoryblock.setAttribute('channel', channel)
  fwStoryblock.setAttribute('mode', 'pinned')
  fwStoryblock.setAttribute('cohort_url', url)
  fwStoryblock.setAttribute('player_placement', 'bottom-left')
  fwStoryblock.setAttribute('autoplay', 'true')
  fwStoryblock.setAttribute('auto_embed_widget', 'true')
  document.body.appendChild(fwStoryblock)
}

/**
 * Attaches URL discovery functionality when enabled via global config
 */
export function setup() {
  const globalConfig = getGlobalConfig()

  if (isTruthy(globalConfig.url_discovery)) {
    const channel = globalConfig.channel
    const url = window.location.href

    const existingStoryblock = Array.from(
      document.querySelectorAll('fw-storyblock[auto_embed_widget="true"]'),
    ).find(
      (el) =>
        el.getAttribute('channel') === channel &&
        el.getAttribute('cohort_url') === url,
    )
    if (existingStoryblock) {
      return
    }

    logInfo('FW: URL Discovery feature is enabled')
    logInfo(`FW: Current URL: ${window.location.href}`)
    logInfo('FW: Channel:', channel)
    createStoryblock(url, channel)
  }
}
